module.exports = __webpack_public_path__ + "img/progress_01_icon.154d28bf.png";